import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=72e2d78e&"
import script from "./Screen.vue?vue&type=script&lang=js&"
export * from "./Screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports